module.exports = __webpack_public_path__ + "img/logo.78991fbb.png";